import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const LoanDocumentNavUI = ({
  loan,
  documentType,
  showEscrowAgreement = false,
  showPledgeAgreement = true,
  showPledgeCumGuarantee = true,
  showNDU = true,
  showCoBorrowerNDU = true,
  showPersonalGuarantee = true
}) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI label='Resolutions' to={`/su/loans/${loan.loanId}/resolutions`} active={documentType === 'resolutions'} />
      <TabLinkUI label='Loan Agreement' to={`/su/loans/${loan.loanId}/loanAgreement/general`} active={documentType === 'loanAgreement'} />
      {showEscrowAgreement && <TabLinkUI label='Escrow Agreement' to={`/su/loans/${loan.loanId}/escrowAgreement/general`} active={documentType === 'escrowAgreement'} />}
      {showPledgeAgreement && <TabLinkUI label='Pledge Agreement' to={`/su/loans/${loan.loanId}/pledgeAgreement/general`} active={documentType === 'pledgeAgreement'} />}
      {showPledgeCumGuarantee && <TabLinkUI label='Pledge Cum Guarantee' to={`/su/loans/${loan.loanId}/pledgeCumGuarantee/general`} active={documentType === 'pledgeCumGuarantee'} />}
      {showNDU && <TabLinkUI label='NDU' to={`/su/loans/${loan.loanId}/ndu/general`} active={documentType === 'ndu'} />}
      {showCoBorrowerNDU && <TabLinkUI label='Co-borrower NDU' to={`/su/loans/${loan.loanId}/coBorrowerNdu/general`} active={documentType === 'coBorrowerNdu'} />}
      {showPersonalGuarantee && <TabLinkUI label='Personal Guarantee' to={`/su/loans/${loan.loanId}/personalGuarantee/general`} active={documentType === 'personalGuarantee'} />}
    </div>
    <div className='g_m_top_50' />
  </div>

export default LoanDocumentNavUI
